export const productCategory=[
    {
        id:1,
        name:"smartphones"
    },
    {
        id:2,
        name:"laptops"
    },
    {
        id:3,
        name:"fragrances"
    }, {
        id:4,
        name:"skincare"
    },
    {
        id:5,
        name:"groceries"
    },
    {
        id:6,
        name:"home-decoration"
    },
    {
        id:7,
        name:"furniture"
    },
    {
        id:8,
        name:"tops"
    },
    {
        id:9,
        name:"womens-dresses"
    },
    {
        id:10,
        name:"womens-shoes"
    },
    {
        id:11,
        name:"mens-shirts"
    },
    {
        id:12,
        name:"mens-shoes"
    },
    {
        id:13,
        name:"mens-watches"
    },
    {
        id:14,
        name:"womens-watches"
    },
    {
        id:15,
        name:"womens-bags"
    },
    {
        id:16,
        name:"mens-jewellery"
    },
    {
        id:17,
        name:"sunglasses"
    },
    {
        id:18,
        name:"automotive"
    },
    {
        id:19,
        name:"motorcycle"
    },
    {
        id:20,
        name:"lighting"
    },
]